import React from 'react';
import { UserProfile, Client } from '@/shared/types';

interface TemplateProps {
  profile: UserProfile;
  client?: Client | null;
  title: string;
  metaData: { label: string; value: string }[];
  children: React.ReactNode;
  footerNote?: string;
  type: string;
  containerClass: string;
  LogoImage: React.FC<{ size: 'sm' | 'md' | 'lg' | 'xl'; className?: string; light?: boolean }>;
  hideHeader?: boolean;
}

const IndustrialTemplate: React.FC<TemplateProps> = ({
  profile, client, title, metaData, children, footerNote, type, containerClass, LogoImage, hideHeader = false
}) => {
  return (
    <div className={containerClass}>
       {!hideHeader && (
         <>
           {/* Warning Stripes Top */}
           <div className="h-4 w-full bg-[repeating-linear-gradient(45deg,#fbbf24,#fbbf24_10px,#000_10px,#000_20px)]"></div>

           <div className="p-12">
              <div className="border-4 border-black p-8 mb-12">
                  <div className="flex justify-between items-start">
                      <div>
                          <h1 className="text-5xl font-black uppercase tracking-tighter mb-2">{profile.name}</h1>
                          <div className="bg-black text-white inline-block px-4 py-1 font-bold text-sm uppercase">
                              {profile.address || "Headquarters"}
                          </div>
                      </div>
                      <LogoImage size="md" className="border-2 border-black p-1"/>
                  </div>
              </div>

              <div className="flex gap-12 mb-12">
                  <div className="flex-1">
                      <h3 className="font-black text-xl uppercase mb-4 border-b-4 border-black pb-2">Client</h3>
                      {client ? (
                          <div className="font-bold text-lg">
                              <p>{client.name}</p>
                              <p className="text-neutral-500">{client.company}</p>
                              <p className="text-sm font-medium mt-1">{client.address}</p>
                          </div>
                      ) : <p className="text-neutral-300 font-bold uppercase">N/A</p>}
                  </div>
                  <div className="flex-1">
                      <h3 className="font-black text-xl uppercase mb-4 border-b-4 border-black pb-2">{type} Details</h3>
                      <div className="space-y-2">
                          {metaData.map((m, i) => (
                              <div key={i} className="flex justify-between border-b border-neutral-200 pb-1">
                                  <span className="font-bold text-neutral-500 uppercase text-xs">{m.label}</span>
                                  <span className="font-black">{m.value}</span>
                              </div>
                          ))}
                      </div>
                  </div>
              </div>
           </div>
         </>
       )}

       <div className="p-12">
          <div className="flex-1 border-t-4 border-black pt-8 industrial-table">
              {children}
          </div>
       </div>

       <div className="mt-auto bg-black text-white p-6 text-center font-bold uppercase tracking-wider text-xs">
           {footerNote}
       </div>
    </div>
  );
};

export default IndustrialTemplate;